import axios from 'api';

export const GetCustomerDetails = () => {
    return axios.get(`/api/customer-audio-details/`)
}

export const GetCallMetaData = ({ search, page, page_size }) => {
    return axios.get(`/api/customer_meta_data/customer_meta_data/?search=${search}&page=${page}&page_size=${page_size}`)
}

export const CreateCallMetaData = async (data) => {
    return axios.post(`/api/customer_meta_data/customer_meta_data/`, data)
}

export const UpdateCallMetaData = async (data) => {
    return axios.put(`/api/customer_meta_data/customer_meta_data/${data.id}/`, data)
}

export const DeleteCallMetaData = async (id) => {
    return axios.delete(`/api/customer_meta_data/customer_meta_data/${id}`)
}